import type { Router } from 'vue-router';
import { getPermissionStore } from '@/store';
import { configureDynamicParamsMenuBatch } from '../helper/menuHelper';

export function createParamMenuGuard(router: Router) {
  router.beforeEach((to, _, next) => {
    // filter no name route
    if (!to.name) {
      next();
      return;
    }

    // menu has been built.
    if (!getPermissionStore().getIsDynamicAddedRoute) {
      next();
      return;
    }

    configureDynamicParamsMenuBatch(getPermissionStore().getBackMenuList, to.params);

    next();
  });
}
